import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import errors from './errors';

import {
  ACTION_ADD_BANNERS,
  ACTION_BANNER__SUCCESS,
  ACTION_DELETE_BANNER__REQUEST,
  ACTION_DELETE_BANNER__SUCCESS,
  ACTION_DELETE_BANNER__FAIL,

  ACTION_LOAD_SITE_BANNERS_EXCHANGE__SUCCESS,
  ACTION_EXCHANGE_BANNER__SUCCESS,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_BANNERS:
      return { ...state, ...action.payload.banners };

    case ACTION_BANNER__SUCCESS:
      return { ...state, [action.payload.banner.id]: action.payload.banner };

    case ACTION_DELETE_BANNER__SUCCESS:
      return _omit(state, [action.payload.bannerId]);

    default:
      return state;
  }
};

const isBannerBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_BANNER__REQUEST:
      return { ...state, [action.payload.bannerId]: true };

    case ACTION_DELETE_BANNER__SUCCESS:
    case ACTION_DELETE_BANNER__FAIL:
      return _omit(state, action.payload.bannerId);

    default:
      return state;
  }
};

const enabledBannerIdsBySiteId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_EXCHANGE_BANNER__SUCCESS:
    case ACTION_LOAD_SITE_BANNERS_EXCHANGE__SUCCESS:
      return { ...state, [action.payload.siteId]: action.payload.mappedBannerIds };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  isBannerBeingDeleted,
  enabledBannerIdsBySiteId,
  errors,
});
